import { showSpinner, hideSpinner } from '/source/_patterns/01-components/spinner/spinner';
import * as subscriptionService from '/source/js/services/subscriptionService';
import { getNextSubscriptionStartDate } from '/source/js/helpers/subscription';
import { setTransactionFlowType } from '/source/js/gtm/IsaGtmCommerce';

let UnexpectedErrorMessage;
const REVIEW_STEP = 'Review';
const REASON_STEP = 'Reason';
const CONFIRMED_STEP = 'Confirmed';

function editStep() {
    let $this = $(this);
    let pageUrl = $this.data('pageurl');
  if (!!pageUrl) {//eslint-disable-line
        window.location.href = pageUrl;
    }
}

function showModifySubscriptionModal() {
    $('.modal-backdrop').hide();
    let id = $(this).attr('id');
    resetDatePicker(id);
    $('.subscriptionModifyModalBackdrop').show();
}

function showStep(stepName) {
    $('.content-step, .footer-step').hide();
    $('#CancelSubscriptionModal .cancel-sub-modal .isa-modal__header.headerContentReasonStep').addClass('d-none');
    $('#CancelSubscriptionButtonText-end').addClass('d-none');
    if(stepName === CONFIRMED_STEP) {
        $('#CancelSubscriptionModal .modal-header .closeModal').hide();
        const siblings = $('h4.isa-modal__header.marker:not(.last-modal)');
        siblings.each(function () {
            $(this).css('display', 'none');
        });
        $('#CancelSubscriptionButtonText-end').removeClass('d-none');
    }
    if(stepName === REASON_STEP) {
        $('#CancelSubscriptionModal .cancel-sub-modal .isa-modal__header').not('.headerContentReasonStep').addClass('d-none');
        $('#CancelSubscriptionModal .cancel-sub-modal .isa-modal__header.headerContentReasonStep').removeClass('d-none');
    }

    $(`#Content${stepName}Step, #Footer${stepName}Step`).show();
}

function showCancelSubscriptionModal() {
    $('.modal-backdrop').hide();
    $('.cancelSubscriptionModalBackdrop').show();
    showStep(REVIEW_STEP);
}

function showCancelReasonStep() {
    showStep(REASON_STEP);
}

function displayCancelReasonDescription(id) {
    const html = $(id).html();
    $('.subscription-cancel-description').empty().html(html);
}

function closeModal(e) {
    let id = $(this).attr('id');
    resetDatePicker(id);
    $('#CancelSubscriptionModal .cancel-sub-modal .isa-modal__header').not('.headerContentReasonStep').removeClass('d-none');
    $('#CancelSubscriptionModal .cancel-sub-modal .isa-modal__header.headerContentReasonStep').addClass('d-none');
    $(e.currentTarget).closest('.modal-backdrop').hide();
    $('.cart-manage-autoship_cta .modifySubscription').focus();
}

function resetDatePicker(id) {
    if(id === 'modalBtnUpdateNextOrderDateBack' || id === 'updateNextOrderDateModalClose' || id === 'CloseModifySubModal') {
        let datePicker = $('#subscription-order-datepicker');
        let savedDate = $(datePicker).attr('data-saved-date');
        let currentDate = $(datePicker).val();
        if(savedDate !== currentDate) {
            $(datePicker).datepicker('update', savedDate);
        }
    }
}

function closeErrorMessage() {
    let $this = $(this);
    $this.parent().addClass('d-none');
}

// #region API calls
async function updateDateAndFrequency(e) {
    e.preventDefault();
    showSpinner('updating date and frequency started');

    var dateValue = $('#subscription-order-datepicker').val();

    // check dateValue if null/empty
    // if yes, it means that current next autoship date is out of range and not selected on calendar
    // substitute with saved date if so to avoid issues and re-add the date to the datepicker to avoid display issue on modal
    if(!dateValue) {
        dateValue = $('#subscription-order-datepicker').data('saved-date');
        $('#subscription-order-datepicker').val(dateValue);
    }

    const frequencyValue = $('#frequency').val();
    const dateFormat = $('#subscription-order-datepicker').attr('placeholder');

    let response;
    try {
        let dateWithProperFormat = getDateFormatted(dateValue, dateFormat);

        let payload = {
            'Frequency': frequencyValue,
            'NextAutoshipDate': dateWithProperFormat
        };
        response = await subscriptionService.updateNextAutoshipAndFrequency(payload);
    } catch (ex) {
        console.log(UnexpectedErrorMessage, ex);
    }

    hideSpinner('updating date and frequency completed');
    if(!response || (response && !response.IsSuccessful)) {
        let $errorMsg = $('.errormessages__modify-subscription');
        $errorMsg.children('.checkout-error__text').html(`<span>${$errorMsg.data('error-message')}</span>`);
        $errorMsg.removeClass('d-none');
        return;
    }

    closeModal(e);

    // Date
    let $datepicker = $('#subscription-order-datepicker');
    let nextOrderDateValue = $datepicker.val();
    $datepicker.attr('subscription-order-datepicker', nextOrderDateValue);
    $('.cart-sidebar__nextSubscriptionDate').text(nextOrderDateValue);

    $('.checkout_subs-change').removeClass('d-flex');
    $('.checkout_subs-change').addClass('d-none');

    // Frequency
    let $frequency = $('#frequency');
    let newFrequency = $frequency.val();
    $frequency.data('selected', newFrequency);
    let frequencyText = $('#SaveModifySubModal').data('frequencytextwithtoken').replace('##FREQUENCY##', newFrequency);
    $('.cart-sidebar__frequecy').text(frequencyText);
}

async function cancelSubscription(e) {
    showSpinner('cancelling subscription started');
    let response;
    let cancelReason = $('#cancelReason').val();
    let request = {
        Reason: cancelReason
    };
    try {
        response = await subscriptionService.cancelSubscription(request);
    } catch (ex) {
        console.log(UnexpectedErrorMessage, ex);
    }
    hideSpinner('cancelling subscription completed');

    if(!response || (response && !response.IsSuccessful)) {
        let $errorMsg = $('.errormessages__cancel-subscription');
        $errorMsg.children('.checkout-error__text').html(`<span>${$errorMsg.data('error-message')}</span>`);
        $errorMsg.removeClass('d-none');
    } else {
        if(window.ga_props) {
            let lastEvent = window.ga_props[window.ga_props.length - 1];
            if(lastEvent) {
                let productsArray = lastEvent.Products.map(product => ({
                    'Sku': product.Sku,
                    'ProductName': product.ProductName
                }));
                const dataObj = {
                    'event': 'Subscription_Cancel_Reason',
                    'customer_id': lastEvent.MemberId,
                    'cancel_reason': cancelReason,
                    'cart_amount': '$' + parseFloat(lastEvent.CartTotal).toFixed(2),
                    'products': productsArray
                };
                window.dataLayer.push(setTransactionFlowType(dataObj));
            }
        }

        $('#CloseCompletedCancelSubBtn').attr('data-redirect', response.RedirectUrl);
        showStep(CONFIRMED_STEP);
    }
}

function cancelSubscriptionConfirmationRedirect(e) {
    let $this = $(this);
    let url = $this.data('redirect');

    if(url) {
        window.location.href = url;
    }
}

function getDateFormatted(date, format) {
    date = date.replace(/\//g, '-');
    format = format.replace(/\//g, '-');
    const dateParts = date.split('-');
    const formatParts = format.split('-');
    let dayKey, monthKey, yearKey;
    for (let i = 0; i < formatParts.length; i++) {
        if(formatParts[i].includes('d')) {
            dayKey = formatParts[i];
        }
        if(formatParts[i].includes('m')) {
            monthKey = formatParts[i];
        }
        if(formatParts[i].includes('y')) {
            yearKey = formatParts[i];
        }
    }

    const day = parseInt(dateParts[formatParts.indexOf(dayKey)]);
    const month = parseInt(dateParts[formatParts.indexOf(monthKey)]);
    const year = parseInt(dateParts[formatParts.indexOf(yearKey)]);

    let strDay = day < 10 ? '0' + day : day;
    let strMonth = month < 10 ? '0' + month : month;
    return strMonth + '-' + strDay + '-' + year;
}
// #endregion

function reInitializeModal(e) {
    const $select = $('#cancelReason');
    let valueToSelect = $select.find('option[value=""]').length > 0 ? ''
        : ($select.find('option[value=" "]').length > 0 ? ' ' : '');
    $select.val(valueToSelect);
    $select.trigger('change');
    closeModal(e);
    showModifySubscriptionModal();
}

function initEventHandlers() {
    $('.modifySubscription').on('click', showModifySubscriptionModal);
    $('body').on('click', '.closeModal', closeModal);
    $('#SaveModifySubModal').on('click', updateDateAndFrequency);
    $('#DisplayCancelSubModal').on('click', showCancelSubscriptionModal);
    $('#ContinueCancelSubBtn').on('click', showCancelReasonStep);
    $('#ConfirmSubCancelBtn').on('click', cancelSubscription);
    $('#CloseCompletedCancelSubBtn').on('click', cancelSubscriptionConfirmationRedirect);
    $('.modal-error__btn').on('click', closeErrorMessage);
    $('.subscription-edit-button').on('click', editStep);
    $('body').on('click', '.open-edit-subscription', reInitializeModal);

    // cancel reason change
    $('#cancelReason').on('change', function(e) {
        let $this = $(this);
        let value = $this.val().trim();
        let confirmSubCancelBtn = $('#ConfirmSubCancelBtn');
        const id = '#key-' + value;
        displayCancelReasonDescription(id);
        confirmSubCancelBtn.attr('disabled', !value);
        confirmSubCancelBtn.toggleClass('active', value !== '');
    });
}

function initFields() {
    // init next order date
    var endDate = new Date();
    endDate.setDate(endDate.getDate() + 90);

    let $updateNextOrderDate = $('.updateNextOrderDate');
    if($updateNextOrderDate.length === 0) {
        $('#subscription-order-datepicker').datepicker({
            format: 'yyyy-mm-dd', // format for date
            startDate: '0d', // start date starts the current day
            endDate: endDate // end date end at 90 days
        });
        return;
    }

    let subscriptionStartDate = $updateNextOrderDate.data('subscriptionstartdate');
    let subscriptionEndDate = $updateNextOrderDate.data('subscriptionenddate');
    let subscriptionDateFormat = $updateNextOrderDate.data('subscriptiondateformat');
    if(!subscriptionStartDate || !subscriptionEndDate || !subscriptionDateFormat) {
        $('#subscription-order-datepicker').datepicker({
            format: 'yyyy-mm-dd', // format for date
            startDate: '0d', // start date starts the current day
            endDate: endDate // end date end at 90 days
        });
        return;
    }

    $('#subscription-order-datepicker').datepicker({
        format: subscriptionDateFormat, // format for date
        startDate: getNextSubscriptionStartDate(subscriptionStartDate, subscriptionDateFormat), // start date starts the next day
        endDate: subscriptionEndDate // end date end at 61 days
    });
}

function initVariables() {
    // set dictionary/translated success message here
    UnexpectedErrorMessage = 'Unexpected error';
}

$(function() {
    if($('#subscriptionModifyModal, #CancelSubscriptionModal').length <= 0) return;

    initEventHandlers();
    initVariables();
    initFields();
});
